'use strict';

var focusHelper = require('base/components/focus');

var DOMPurify = window.DOMPurify;

/**
 * Renders a modal window that will track the users consenting to accepting site tracking policy
 */
function showConsentModal() {
    var trackingConsentData = $('.tracking-consent');
    if (!trackingConsentData.data('caonline')) {
        return;
    }

    var urlContent = trackingConsentData.data('url');
    var urlAccept = trackingConsentData.data('accept');
    var urlReject = trackingConsentData.data('reject');
    var textYes = trackingConsentData.data('accepttext');
    var textNo = trackingConsentData.data('rejecttext');
    var textHeader = trackingConsentData.data('heading');
    var tokenName = trackingConsentData.data('tokenname');
    var token = trackingConsentData.data('token');

    var htmlString =
        '<!-- Modal -->' +
        '<div class="modal show" id="consent-tracking" data-backdrop="static" aria-modal="true"' +
        'role="dialog" style="display: block;">' +
        '<div class="modal-dialog">' +
        '<!-- Modal content-->' +
        '<div class="modal-content">' +
        `<div class="modal-header">${textHeader}</div>` +
        '<div class="modal-body"></div>' +
        '<div class="modal-footer">' +
        '<div class="button-wrapper">' +
        `<button class="affirm btn btn-primary" data-url="${urlAccept}" autofocus data-dismiss="modal">` +
        `${textYes}</button>` +
        `<button class="decline btn btn-primary" data-url="${urlReject}" data-dismiss="modal" >${textNo}</button>` +
        '</div>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '</div>';
    $.spinner().start();
    $('body').append(htmlString);

    $.ajax({
        url: urlContent,
        type: 'get',
        dataType: 'html',
        success(response) {
            $('.modal-body').html(DOMPurify.sanitize(response));
            $('#consent-tracking').modal('show');
        },
        error() {
            $('#consent-tracking').remove();
        }
    });

    $('#consent-tracking .button-wrapper button').click(function (e) {
        e.preventDefault();
        var url = $(this).data('url');
        var data = {};
        data[tokenName] = token;
        $.ajax({
            url,
            type: 'post',
            data,
            dataType: 'json',
            success(response) {
                // Only hide modal if the operation is successful - don't want to give a false impression
                if (response.success) {
                    $('#consent-tracking').remove();
                    $.spinner().stop();
                }
            },
            error(err) {
                // Expected error response is for CSRF failure, which will include a redirect to CSRF-Fail
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                }
            }
        });
    });
}

/**
 * Parse the OptanonConsent cookie to extract the groups parameter
 * @returns {string} The groups value (e.g., "C0001:1,C0002:1,C0003:0")
 */
function getOptanonConsentGroups() {
    const cookieNameSelector = 'OptanonConsent=';
    const cookie = document.cookie.split('; ').find((c) => c.startsWith(cookieNameSelector));

    const subStrCookievalue = cookie ? decodeURIComponent(cookie.substring(cookieNameSelector.length)) : '';
    const groupsMatch = subStrCookievalue.match(/groups=([^&]+)/);
    const groups = groupsMatch ? groupsMatch[1] : null;
    return groups;
}

module.exports = function () {
    if ($('.consented').length === 0 && $('.tracking-consent').hasClass('api-true')) {
        showConsentModal();
    }

    if ($('.tracking-consent').hasClass('api-true')) {
        $('.tracking-consent').click(function () {
            showConsentModal();
        });
    }

    $('body').on('shown.bs.modal', '#consent-tracking', function () {
        $('#consent-tracking').siblings().attr('aria-hidden', 'true');
        $('#consent-tracking .affirm').focus();
    });

    $('body').on('hidden.bs.modal', '#consent-tracking', function () {
        $('#consent-tracking').siblings().attr('aria-hidden', 'false');
    });

    $('body').on('keydown', '#consent-tracking', function (e) {
        var focusParams = {
            event: e,
            containerSelector: '#consent-tracking',
            firstElementSelector: '.affirm',
            lastElementSelector: '.decline',
            nextToLastElementSelector: '.affirm'
        };
        focusHelper.setTabNextFocus(focusParams);
    });

    // Event fired by otSDKStub.js each time the OnetrustActiveGroups are updated (page load or user interaction)
    $(window).on('OneTrustGroupsUpdated', function (e) {
        var groups = getOptanonConsentGroups();
        var lastStoredGroups = sessionStorage.getItem('lastOneTrustGroups');

        if (groups && groups !== lastStoredGroups && window.consentTrackingUrl) {
            sessionStorage.setItem('lastOneTrustGroups', groups);

            $.ajax({
                url: window.consentTrackingUrl,
                type: 'POST',
                contentType: 'application/json',
                data: JSON.stringify({ groups }),
                dataType: 'json',
                error(err) {
                    console.error('Error updating OneTrust Analytics consent on server:', err);
                }
            });
        }
    });
};
